import { z } from 'zod/v3';
import { DataObjectType } from '../types';

export const zDataObjectType = z.nativeEnum(DataObjectType);
